import { render, staticRenderFns } from "./MainDownload.vue?vue&type=template&id=3ce967b6&scoped=true&"
import script from "./MainDownload.vue?vue&type=script&lang=js&"
export * from "./MainDownload.vue?vue&type=script&lang=js&"
import style0 from "./MainDownload.vue?vue&type=style&index=0&id=3ce967b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce967b6",
  null
  
)

export default component.exports